"use strict";

export default {
  async getUser({ commit }, payload) {
    const { api, page = 1, limit = 5, search = "" } = payload;

    try {
      const res = await api.get(
        `/users?page=${page}&limit=${limit}&search=${search}`
      );
      commit("setUser", res.data.data);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async deactivateUser(_, payload) {
    const { api, email, type } = payload;

    try {
      const res = await api.post(`/users/deactivate`, { email, type });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },
};
